<template>
  <div>
    <filter-sidebar
      :visible="showFilterSidebar"
      :fenomen-list="fenomenList"
      :inf-id.sync="getInfId"
      :filter-options.sync="filterOptions"
      @hidden="showFilterSidebar = false"
      @filters-cleared="handleFiltersCleared"
      v-if="showFilterSidebar && filterBtnShow"
      :type="params && params.filter ? params.filter.type : null"
    />
    <category-add-new
        v-if="isAddNewCategorySidebarActive" 
        :is-add-new-category-sidebar-active.sync="isAddNewCategorySidebarActive"
        :editing-category="editingCategory"
        @refetch-data="refetchData"
        @save-category="loadTypeData"
        :type="params && params.filter ? params.filter.type : null"
        /> 
    <link-add-new
        v-if="addBtnShow && isAddNewLinkSidebarActive" 
          :is-add-new-link-sidebar-active.sync="isAddNewLinkSidebarActive"
          :editing-link="editingLink"
          @refetch-data="refetchData"
          @copy-emit="copyLink"
          :fenomenList="fenomenList"
          :type="params && params.filter ? params.filter.type : null"
          @update-editing-link="editingLink = null"
          :platform="platform"
          :typeData="typeData"
          @open-create-category="isAddNewCategorySidebarActive = true"
          />    
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Gösterim Sayısı</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>sonuç</label>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
            v-if="$route.name!='influencer-card'"
            >
             <div class="d-flex align-items-center mr-1"  v-if="!isFenomen">

              
              <!-- ARŞİV -->
              <b-button
                variant="outline-success"
                size="sm"
                class="mr-1"
                :class="{ active: viewType === 'active' }"
                @click="viewType = 'active'"
              >
                <feather-icon icon="CheckCircleIcon" size="14" />
                Aktifler
              </b-button>

              <!-- ARŞİV -->
              <b-button
                variant="outline-primary"
                size="sm"
                class="mr-1"
                :class="{ active: viewType === 'archive' }"
                @click="viewType = 'archive'"
              >
                <feather-icon icon="ArchiveIcon" size="14" />
                Arşivdekiler
              </b-button>

              <!-- TRASH -->
              <b-button
                variant="outline-danger"
                size="sm"
                :class="{ active: viewType === 'trash' }"
                @click="viewType = 'trash'"
              >
                <feather-icon icon="Trash2Icon" size="14"/>
                Silinenler
              </b-button>

            </div>


              <!-- Search -->
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block col-4 mr-1"
                placeholder="Ara..."
              />
              <b-button
              v-if="(filterBtnShow || $route.name == 'links') && !multiLinks && !isFenomen"
              @click="showFilterSidebar = !showFilterSidebar"
              class="mr-1 d-flex"
                variant="warning"
              >
                <feather-icon
                  icon="FilterIcon"
                  class="mr-50"
                />
                <span class="align-middle">Filtre</span>
            </b-button>
            <!-- <div class="dropdown-style d-flex">
              <v-select
                id="inf_id"
                :options="safeOptions"
                @input="getInfId = $event"
                :reduce="reduceFunction"
                class="w-100 fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary mr-50"
                placeholder="Tüm Fenomenler"
                multiple
                v-if="!isFenomen && additionalParams.filter.type==0"
              />
            </div> -->
              <b-button
                v-if="$store.getters['user/isAdmin'] || addBtnShow"
                @click="isAddNewLinkSidebarActive = true"
                variant="primary"
                class="create_link_btn bg-primary text-white d-flex text-center justify-content-center align-items-center cursor-pointer"
              >
                <FeatherIcon icon="PlusIcon" size="16" class="text-white mr-1"></FeatherIcon>
                Oluştur
              </b-button>
              <div v-if="multiBtnShow" class="ml-1">
              </div>
              <div
                v-if="multiBtnShow || typeData.key == 'influencer'"
                class="ml-1 d-flex align-items-center flex-column"
              >
                  <b-form-checkbox
                    class="ml-1"
                    name="check-button"
                    switch
                    inline
                    :checked="multiLinks"
                    @change="multiLinks = !multiLinks"
                    v-if="$store.getters['user/isAdmin'] || $store.getters['user/isDeveloper']"
                  >
                    {{ $route.name == 'multi-links' ? 'Kategoriler' : 'Gruplar' }}
                  </b-form-checkbox> 
                  <b-button variant="success" @click="isAddNewCategorySidebarActive = true "  size="sm" class="mt-1" v-if="multiBtnShow">
                      Grup Ekle
                  </b-button>
              </div>
          </b-col>
        </b-row>

      </div>
      <b-table
        ref="refLinkListTable"
        class="position-relative links-table"
        :items="fetchLinks"
        responsive
        :fields="resolvedTableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        :busy.sync="isLoading"
        show-empty
        empty-text="Sonuç bulunamadı"
        :sort-desc.sync="isSortDirDesc"
        :tbody-tr-class="rowClass"
      >

      <!-- Loading Slot -->
      <template #table-busy>
        <div class="text-center my-2 text-muted">
          <b-spinner small class="mr-1"  />
          <span>Paylaşımlar yükleniyor...</span>
        </div>
      </template>

      <template #cell(type)="data">
        

        <template v-if="data.item.type=='0'">
          <FeatherIcon icon="UserCheckIcon"></FeatherIcon>
            <b> FENOMEN</b> 
        </template>

        <template v-else-if="data.item.type=='1'">
          <FeatherIcon icon="CropIcon"></FeatherIcon>
          <b> STORY</b>
        </template>

        <template v-else-if="data.item.type=='2'">
          <FeatherIcon icon="MessageSquareIcon"></FeatherIcon>
          <b> SMS</b>
        </template>

        <template v-else-if="data.item.type=='3'">
          <FeatherIcon icon="ScissorsIcon"></FeatherIcon>
          <b> BIO</b>
        </template>

        <template v-else-if="data.item.type=='4'">
          <FeatherIcon icon="MessageCircleIcon"></FeatherIcon>
          <b> WHATSAPP</b>
        </template>

        <template v-else>
            <b> BİLİNMEYEN</b> 
        </template>

      </template>

      <template #cell(platform)="data">
            <b> {{ data.item.platform.name }}</b> 
        </template>
      
      <!-- Fiyat gösterimi -->
      <template #cell(id)="data">
        <template v-if="isGroupItem(data.item)">

          <!-- Gizli checkbox (BootstrapVue'nun row details için gerekli) -->
          <b-form-checkbox
            v-model="data.detailsShowing"
            @change="handleToggle(data)"
            style="display: none;"
          ></b-form-checkbox>

          <!-- Kullanıcının tıklayacağı ikon -->
          <div @click="handleToggle(data)" style="cursor: pointer;">
            <FeatherIcon icon="ChevronUpIcon" v-if="data.detailsShowing" />
            <FeatherIcon icon="ChevronDownIcon" v-else />
          </div>

        </template>
        <template v-else>
          {{data.item.id}}
        </template>
      </template>


      <template #cell(cart_count)="data">
          <span v-if="data.item.is_internal_domain==0">-</span>
          <span v-else><b>{{ data.item.cart_count }}</b> </span>
      </template>

      <template #cell(order_count)="data">
          <span v-if="data.item.is_internal_domain==0">-</span>
          <span v-else><b>{{ data.item.order_count }}</b> Adet</span>
      </template>

      <template #cell(image)="data" >
        <b-media
        v-b-popover.hover.right.html="popoverContent(data.item.image)"
        title="Paylaşım Görseli"
        custom-class="wide-popover"
      >
        <img :src="imagePath+'/links/thumb/'+data.item.image" style="max-width: 100px;" v-if="data.item.image">
      </b-media>
      </template>
      

      <!-- PAge türü gösterimi şimdilik pasif [23,232...] çok uzadı -->
      <!-- <template #cell(page_type)="data">
        {{ data.item.page_type }} <b>{{ data.item.category_id ? 'ID:' + data.item.category_id : (data.item.product_id ? 'ID:' + data.item.product_id : '') }} </b>
      </template> -->

      <!-- PAge türü gösterimi -->
      <template #cell(link_ici_odeme_orani)="data">
        <div class="d-flex align-items-center" v-if="data.item.influencer && data.item.influencer.id != 1">
        <b-badge
          pill
          variant="success">
          Link İçi : <b>%{{ data.item.link_ici_odeme_orani }}</b>
        </b-badge>
        <b-badge
          class="ml-1"
          pill
          variant="danger">
          Link Dışı : <b>%{{ data.item.link_disi_odeme_orani }}</b>
        </b-badge>
      </div>
      </template>

      <template #cell(username)="data">
        <!-- Paylaşım Link -->
        <span v-if="data.item.influencer && data.item.influencer.id && data.item.type==0" >
          <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username"/>
        </span>
      </template>

      <template #cell(campaign_name)="data"  >
        <!-- Paylaşım Link -->
        <template v-if="isGroupItem(data.item)">
            <campaign-link-btn :name="data.item.campaign_name" :group="true" :route="getLinkName(data.item)" />
            <b-badge pill variant="info">
              {{ data.item.links_count }} {{ data.item.type == 1 ? 'Fenomen' : 'Link' }} 
            </b-badge>
        </template>
        <template v-else>
          <!-- <span v-if="data.item.influencer && data.item.influencer.id && data.item.type==0" >
            <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username"/> /
          </span> -->
          <campaign-link-btn :name="data.item.campaign_name.replace(data.item.influencer.username+'-','')" :route="getLinkName(data.item)" />
        </template>

        
      </template>

      <template #cell(links_count)="data">
            <b>{{ data.item.links_count }}</b> {{ data.item.platform.id == 1 ? 'Fenomen' : 'Link' }} 
      </template>
      <template #cell(actions)="data">
        <div class="d-flex align-items-center">

          <!-- Detay Gör → dışarıda kalacak -->
          <router-link :to="getLinkName(data.item)" class="px-1">
            <feather-icon 
              v-b-tooltip.hover.v-primary
              title="Detay Gör"
              icon="EyeIcon"
              class="cursor-pointer" size="22" />
          </router-link>

          <!-- 3 Nokta Menü -->
          <b-dropdown
            right
            no-caret
            variant="link"
            toggle-class="p-0 m-0"
            class="px-1"
            boundary="viewport"
            menu-class="campaign-actions-menu"
          >
            <!-- 3 nokta icon -->
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="22" class="cursor-pointer" />
            </template>

            <!-- --- MENÜ İÇERİSİNDEKİ BUTONLAR --- -->

            <!-- Panoya Kopyala -->
            <b-dropdown-item v-if="!isGroupItem(data.item)" @click="copyLink(data.item)">
              <feather-icon icon="CopyIcon" size="16" class="mr-1" />
              Kısa Linki Kopyala
            </b-dropdown-item>

            <!-- Düzenle -->
            <b-dropdown-item v-if="!isFenomen" @click="editLink(data.item)">
              <feather-icon icon="EditIcon" size="16" class="mr-1" />
              Düzenle
            </b-dropdown-item>

            <!-- Whatsapp ile paylaş -->
            <b-dropdown-item 
              v-if="!isFenomen && !isGroupItem(data.item)" 
              @click="copyLink(data.item,'whatsapp')"
            >
              <img src="@/assets/images/icons/whatsapp.png" width="16" class="mr-1">
              Whatsapp ile Paylaş
            </b-dropdown-item>

            <!-- Sil -->
            <b-dropdown-item
              v-if="!isFenomen"
              class="bg-danger"
              @click="deleteItem(data.item)"
            >
              <!-- ÇÖP KUTUSU -->
              <div v-if="data.item.is_deleted">
                <feather-icon icon="RotateCcwIcon" size="16" class="mr-1 text-white" />
                <span class="text-white">Geri Al</span>
              </div>

              <!-- ARŞİVDE -->
              <div v-else-if="data.item.is_archived">
                <feather-icon icon="ArchiveIcon" size="16" class="mr-1 text-white" />
                <span class="text-white">Arşivden Çıkar</span>
              </div>

              <!-- AKTİF -->
              <div v-else>
                <feather-icon icon="Trash2Icon" size="16" class="mr-1 text-white" />
                <span class="text-white">Sil</span>
              </div>
            </b-dropdown-item>


          </b-dropdown>
        </div>
      </template>


      <template #cell(status)="data">

        <b-badge
          pill
          variant="danger"
          class="text-capitalize mr-1"
          v-if="data.item.is_archived" >
          Arşiv
        </b-badge>
        <b-badge
          pill
          :variant="`${resolveUserVerify(data.item)}`"
          class="text-capitalize"
          v-if="!data.item.category && !data.item.is_deleted"
        >
          {{ data.item.short_data.wait ? 'Bekleniyor' : (data.item.status ? 'Aktif' : 'Pasif') }}
        </b-badge>
        <b-badge
          pill
          :variant="`light-${data.item.status ? 'success' : 'danger'}`"
          class="text-capitalize"
          v-else-if="!data.item.is_deleted"
        >
          {{ data.item.status ? 'Aktif' : 'Pasif' }} 
        </b-badge>

        <div v-if="data.item.is_deleted" class="mt-5px">
          <b-badge pill variant="danger" class="text-capitalize mr-1">
             {{ calcTrashInfo(data.item.deleted_at) }}
          </b-badge>
        </div>
      </template>

      <template #cell(created_date)="data">
          {{ formatDate(data.item.created_date) }}
        </template>

      <template #cell(start_date)="data">
        {{ data.item.start_date ? formatDate(data.item.start_date) : '' }}
      </template>

      <template #cell(end_date)="data">
        {{ data.item.end_date ? formatDate(data.item.end_date) :'' }}
      </template>

      <template #cell(total_amount)="data">
        <div class="text-right" >{{ data.item.is_internal_domain==0 ? '-' : priceFormat(data.item.total_amount) }}</div>
      </template>

      <!-- is_internal_domain 1 0 Firma dışı bağlantı-->
       <template #cell(is_internal_domain)="data">
        <b-badge
          pill
          :variant="data.item.is_internal_domain ? 'success' : 'danger'"
          class="text-capitalize"
        >
          {{ data.item.is_internal_domain ? 'İç Bağlantı' : 'Dış Bağlantı' }}
        </b-badge>
      </template>

      <!-- Eğer grup kampanya ise bağlı kampanyalar gösterilecek -->
       
      <template #row-details="data">
          <campaign-sub-link 
          v-if="data.item.links.length>0"
          :linksData="data.item.links" 
          class="bg-white" 
          @edit-link="editLink"
          :parentTableColumns="tableColumns"
          @refresh-data="refetchData"></campaign-sub-link>
      </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalLinks"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
  </b-card>

  <div class="m-2 d-flex justify-content-center" v-if="viewType=='trash'">
    <b-alert
      show
      variant="danger"
    >
      <div class="alert-body d-flex align-items-center">
        <feather-icon
          icon="InfoIcon"
          class="mr-50 mt-25"
        />
        <div>Kısa linkler ile birlikte paylaşımlar 30 gün içinde silinecektir. Silindikten sonra 404 ekranına düşecektir.</div>
      </div>
    </b-alert>
  </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTableLite, VBTooltip, VBPopover, BFormCheckbox,
  BAlert,
  BSpinner
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref,watch, onMounted, computed  } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useLinksList from '@/components/link/useLinksList'
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
import LinkAddNew from '@/components/link/LinkAddNew.vue'
import CategoryAddNew from '@/components/link/CategoryAddNew.vue'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'
import CampaignSubLink from './CampaignSubLink.vue'
import { useRouter, getFinalPath } from '@core/utils/utils'
import FilterSidebar from '@/components/link/LinksListFilters.vue'
import axiosIns from '@/axios'
import Swal from 'sweetalert2'

export default {
  components: {
    
    BCard,
    BRow,
    BCol, 
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BTableLite,
    BMedia,
    BFormCheckbox,
    BAlert,
    BSpinner,
    
    vSelect,
    CampaignLinkBtn,
    InfluencerLinkBtn,
    LinkAddNew,
    CategoryAddNew,
    CampaignSubLink,
    FilterSidebar
  },
  directives: {
    'b-popover': VBPopover,
    'b-tooltip': VBTooltip
  },
  props: {
    tableColumns: {
      type: Array,
      default: null,
    },
    params: {
      type: Object,
      default: () => ({}) // Boş bir nesne
    },
    InfId: {
      type: [String, Number],
      default: null,
    },
    filterBtnShow:{
      type:Boolean,
      default:false
    },
  },
  computed: {
    safeOptions() {
      return Array.isArray(this.fenomenList) ? this.fenomenList : [];
    },
  },
  methods: {
    reduceFunction(val) {
      return val && typeof val === 'object' && 'value' in val ? val.value : null;
    },
    rowClass(item) {
      if (!item) return;
      let classes="";
      if(item.links && item.group_id){
        classes = 'clickable-row';
      }else if(item.type==1){
        classes = 'bg-story'
      }else if(item.bio_active==1){
        classes = 'bg-active-bio'
      }else if(item.type==2){
        classes = 'bg-sms'
      }else if(item.type==4){
        classes = 'bg-whatsapp'
      }
      return classes
    },
    popoverContent(image) {
      const fullUrl = this.imagePath + '/links/' + image;
      return `<img src="${fullUrl}" style='max-width: 460px; display: block;'>`;
    },
    getLinkName(item) {
      let route = {
        name: '',
        params: {
          id: item.id
        }
      };

      if (item.category) {
        route.name = "campaign-group-detail";
      } else if (item.type == 1) {
        route.name = "story-detail";
      } else if (item.type == 2) {
        route.name = "sms-detail";
      } else if (item.type == 4) {
        route.name = "whatsapp-detail";
      } else if (item.type == 3) {
        route.name = "bio-detail";
        route.params.platform_id = item.platform.id;

      }else {
          route.name = "campaign-detail";
        }

      return route;
    },
    isGroupItem(item){
      return item.category  
    },
    calcTrashInfo(deletedAt) {
      if (!deletedAt) return ''

      const deletedDate = new Date(deletedAt)
      const now = new Date()

      const totalDays = 30
      const diffTime = now - deletedDate
      const passedDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
      const remainingDays = totalDays - passedDays

      if (remainingDays <= 0) {
        return 'Silinmek üzere'
      }

      return `${remainingDays} gün kaldı`
    }
  },
  setup(props, { emit }) {
    
    let platform = props.params && props.params.filter ? props.params.filter.platform_id : null 
    
    const imagePath = getFinalPath();
    const toast = useToast()
    const { route } = useRouter()
    console.log("Route:", route.value); // route değerini kontrol et
    const isAddNewLinkSidebarActive = ref(false)
    const isAddNewCategorySidebarActive = ref(false)
    const editingLink = ref(null) // Düzenlenecek link bilgisi
    const editingCategory = ref(null) // Düzenlenecek kategori bilgisi
    const showFilterSidebar = ref(false)
    const typeData = ref({}) // Dinamik olarak yüklenecek type bilgisi

    // `useLinksList`'ten değerleri al
    
    const {
      fetchLinks,
      fenomenList,
      tableColumns: defaultTableColumns,
      perPage,
      currentPage,
      totalLinks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      viewType,
      getInfId, // Dinamik olarak bağlanacak
      isSortDirDesc,
      refLinkListTable,
      refetchData,
      additionalParams,
      filterOptions,
      multiLinks,
      isLoading
    } = useLinksList()

    //story özel link
    
    additionalParams.value = { ...props.params };

    const loadTypeData = () => {
      let link_type = route.value.params.type
      if(route.value.name=='bio' || route.value.name=='bio-detail'){
        link_type = route.value.params.key
      }
       axiosIns.get('/link/type', {
        params: { key: link_type }
      }).then((res) => {
        typeData.value = res.data.data[0]
      }).catch((err) => {
        console.error('Link type yüklenirken bir hata oluştu:', err)
      })
    }
    watch(() => route.value.params.type, () => {
      loadTypeData()
    })

    watch(() => multiLinks.value, (newVal) => {
      if (newVal) {
        resolvedTableColumns.value = props.tableColumns.filter(col => col.multiShow !== false)
      } else {
        resolvedTableColumns.value = [...props.tableColumns]
      }
    })

    watch(() => props.params, async (newParams) => {
        additionalParams.value = { ...newParams };  
    }, { deep: true });

    watch(() => props.tableColumns, async (newTableColumns) => {
        resolvedTableColumns.value = [...newTableColumns];  
    }, { deep: true });

    onMounted(() => {
      loadTypeData()
    })
    
    // Eğer `props.getInfId` varsa `getInfId` değerini güncelle
    if (props.InfId) {
      getInfId.value = props.InfId
    }

    // `props.getInfId`'yi dinamik olarak izlemek için `watch` kullan
    watch(() => props.InfId, (newVal) => {
      if (newVal) {
        getInfId.value = newVal
      }
    })

    watch(() => isAddNewLinkSidebarActive.value, (newVal) => {
      if(!newVal){
        editingLink.value = null 
      }
    })

    watch(() => isAddNewCategorySidebarActive.value, (newVal) => {
      if(!newVal){
        editingCategory.value = null 
      }
    })

    
    const handleToggle = async (data) => {
      // details kapalı → açılıyor
      if (!data.detailsShowing) {
          // Ürünler daha önce yüklenmediyse isteği yap
          if (!data.item.products) {
          try {
              const res = await axiosIns.get(`/link`, {
                params: { filter: { group_id: data.item.id } }
              })
              // Dönen ürünleri sipariş kaydına ekle
              data.item.links = res.data.data?.Links || []

          } catch (e) {
              console.error('Ürün bilgisi alınamadı:', e)
              data.item.links = []
          }
          }
      }
      // BootstrapVue’nun kendi detay toggle fonksiyonunu çağır
      data.toggleDetails()
    }

    
    const handleFiltersCleared = () =>{
      showFilterSidebar.value=false
    }
    
    const resolveUserVerify = verify => {
        if (verify.short_data.wait == 1) return 'warning'
        if (verify.status == '0') return 'dark'
        if (verify.status == '1') return 'success'
        return 'primary'
    }
    
    const resolvedTableColumns = ref(props.tableColumns || defaultTableColumns)

    const deleteItem = async (link) => {
      const isCategoryItem = !!(link.category || link.group_id)
      const targetId = link.category ? link.id : (link.group_id || link.id)
      const archiveEndpoint = isCategoryItem ? `/link/category/archive/${targetId}` : `/link/archive/${targetId}`
      const deleteEndpoint = isCategoryItem ? `/link/category/${targetId}` : `/link/${targetId}`

      // Eğer link arşivdeyse -> direkt arşivden çıkar
      if (link.is_archived) {
        try {
          const res = await axiosIns.post(archiveEndpoint);

          if (res.data.success) {
            Swal.fire('Geri Alındı!', 'Link arşivden çıkarıldı.', 'success');
            refetchData();
          } else {
            Swal.fire('Hata!', res.data.error ?? 'İşlem başarısız.', 'error');
          }
        } catch (err) {
          Swal.fire('Hata!', 'Arşivden çıkarma sırasında bir hata oluştu.', 'error');
        }
        return;
      }

      // Eğer link arşivdeyse -> direkt arşivden çıkar
      if (link.is_deleted) {
        try {
          const res = await axiosIns.delete(deleteEndpoint);

          if (res.data.success) {
            Swal.fire('Geri Alındı!', 'Link çöp kutusundan çıkarıldı.', 'success');
            refetchData();
          } else {
            Swal.fire('Hata!', res.data.error ?? 'İşlem başarısız.', 'error');
          }
        } catch (err) {
          Swal.fire('Hata!', 'Çöp kutusundan çıkarma sırasında bir hata oluştu.', 'error');
        }
        return;
      }

      // Arşivli değilse -> normal sil/arsiv logic
      const onlyArchive = link.event_count > 0;

      Swal.fire({
        title: onlyArchive ? 'Arşive Kaldır' : 'İşlem Seçin',
        text: onlyArchive 
          ? 'Bu link silinemez. Arşive kaldırmak ister misiniz?' 
          : 'Bu link için ne yapmak istiyorsunuz?',
        icon: 'question',

        showCancelButton: true,
        showDenyButton: true,
        showConfirmButton: !onlyArchive,

        confirmButtonText: 'Çöp Kutusuna Gönder',
        denyButtonText: 'Arşive Kaldır',
        cancelButtonText: 'Vazgeç',

        customClass: {
          actions: 'swal-actions-spacing'
        },

        confirmButtonColor: '#d33',
        denyButtonColor: '#f0ad4e',
      })
      .then(async (result) => {

        // ************ ARŞİVLE ************
        if (result.isDenied) {
          const res = await axiosIns.post(archiveEndpoint);
          
          if (res.data.success) {
            Swal.fire('Arşivlendi!', 'Link arşive kaldırıldı.', 'success');
            refetchData();
          } else {
            Swal.fire('Hata!', res.data.error ?? 'Arşivleme hatası.', 'error');
          }
          return;
        }

        if (onlyArchive) return;

        // ************ SİL ************
        if (result.isConfirmed) {
          const res = await axiosIns.delete(deleteEndpoint);

          if (res.data.success) {
            Swal.fire('Silindi!', 'Link çöp kutusuna gönderildi.', 'success');
            refetchData();
          } else {
            Swal.fire('Hata!', res.data.error ?? 'Silme hatası.', 'error');
          }
        }

      });
    };


    const editLink = (link) => {

      if(link.category){
        let modifyLink = {
          ...link,
          status: !!link.status
        };
        isAddNewCategorySidebarActive.value = true;
        setTimeout(() => {
          editingCategory.value = modifyLink;
        }, 100);
      }else{
        let modifyLink = {
          ...link,
          inf_id:link.influencer?.id || null, // tek fenomen id
          status: !!link.status
        };
        isAddNewLinkSidebarActive.value = true;

        setTimeout(() => {
          editingLink.value = modifyLink;
        }, 100);
      }
    };

    const copyLink = (data,whatsapp=null) => {
      if (!data.short_url) {
        toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            icon: 'InfoIcon',
            variant: 'danger',
            title: 'Link kopyalama hatası!',
          },
        })
        return
      }
      const createlink = data.short_url ? data.short_url : data.short_data.long_url;
      if (whatsapp) {
        // Whatsapp paylaşım linki oluştur
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Paylaşım linki: ${createlink}`)}`;
        
        // Yeni sekmede Whatsapp linkini aç
        window.open(whatsappUrl, '_blank');
      } else {
        // Linki panoya kopyala
        navigator.clipboard.writeText(createlink)
          .then(() => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'CopyIcon',
                variant: 'success',
                title: 'Link kopyalandı!',
              },
            });
          })
          .catch((err) => {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'InfoIcon',
                variant: 'warning',
                title: `Link kopyalanırken hata oluştu: ${err.message}`,
              },
            });
          });
      }


    }
    
    const multiBtnShow = computed(() => {
      return typeData.value.use_category && (store.getters['user/isAdmin'] || store.getters['user/isDeveloper'])
    })

    const addBtnShow = computed(() => {
      const type = typeData.value.key

      const permissions = store.state.user.userData.permissions || []
      console.log('User Permissions:', permissions); // Kullanıcı izinlerini kontrol et
      if(store.getters['user/isDeveloper']){
        return true
      }
      if(store.getters['user/isFenomen']){
        return false
      }
      if (type === 'influencer') {
        return permissions.includes('paylasimlar.fenomen_paylasimi_yapabilir_duzenleyebilir')
      } else if (type === 'story') {
        return permissions.includes('firma_paylasimi.story_ekleyebilir_duzenleyebilir')
      } else if (type === 'sms') {
        return permissions.includes('firma_paylasimi.sms_ekleyebilir_duzenleyebilir')
      } else if (type === 'whatsapp') {
        return permissions.includes('firma_paylasimi.whatsapp_ekleyebilir_duzenleyebilir')
      } else if (route.value.name === 'bio' || route.value.name === 'bio-detail') {
        return permissions.includes('firma_paylasimi.bio_ekleyebilir_duzenleyebilir')
      }

      return permissions.includes('firma_paylasimi.sms_ekleyebilir_duzenleyebilir')
    })

    return {
      editingLink,
      editingCategory,
      editLink,
      copyLink,
      deleteItem,
      isAddNewLinkSidebarActive,
      isAddNewCategorySidebarActive,
      fetchLinks,
      fenomenList,
      perPage,
      currentPage,
      totalLinks,
      dataMeta,
      perPageOptions,
      resolvedTableColumns,
      searchQuery,
      getInfId,
      sortBy,
      viewType,
      isSortDirDesc,
      refLinkListTable,
      refetchData,
      resolveUserVerify,
      additionalParams,
      showFilterSidebar,
      filterOptions,
      multiLinks,
      handleFiltersCleared,
      imagePath,
      isLoading,
      platform,
      handleToggle,
      typeData,
      loadTypeData,
      multiBtnShow,
      addBtnShow
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.fixed-width {
    min-width: 230px; /* İhtiyaca göre genişliği ayarlayın */
    width: 100%;
  }
.dropdown-style{
  .vs__dropdown-toggle{
    border:none; 
  }
  .dropdown-toggle::after{
    right: 10px;
    left: inherit;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.b-table-details>td{
  padding: 0;
}
.bg-story {
  background-color: #e3cf9d; /* Hafif gri arkaplan */
}
.bg-active-bio{
  background-color: #16ac34;
  color:#FFF;
  a{
    color:#FFF;
  }
}
.bg-sms {
  background-color: #a07b98; /* Hafif gri arkaplan */
  color: #FFF;
  a:not(.dropdown-menu a){
    color:#FFF;
  }
}
.bg-whatsapp {
  background-color: #25D366; /* Whatsapp yeşili */
  color: #FFF;
  a:not(.dropdown-menu a){
    color:#FFF;
  }
}
.clickable-row {
  cursor: pointer;
  background-color: #bed0e1; /* Hafif gri arkaplan */
}
.vs__selected .vs__deselect{
  fill: white;
}
.b-popover {
  max-width: 500px !important; /* veya ne kadar geniş istersen */
}
.swal-actions-spacing {
  display: flex !important;
  gap: 10px !important;
}
.links-table {
  min-height: 400px; /* Tablo boşken minimum yükseklik */
}

.campaign-actions-menu {
  z-index: 3000 !important;
}
</style>
